import { Box, CircularProgress } from '@mui/material';

export const FullScreenProgress = () => {
  return (
    <Box width='100%' height='100vh' display='flex' alignItems='center' justifyContent='center'>
      <CircularProgress size={120} />
    </Box>
  );
};
